export default __webpack_public_path__ + "static/luxeve-fire-pit-bronze-vein-0065c2c1876146c9225085ddabbbeb76.jpg";